<template>
  <router-view />
</template>
<script>
import { checkifLoggedIn, getUserDetailsLocalStorage } from "@/utils/functions";

export default {
  name: "mainDefault",
  methods: {
    redirectIfLoggedIn() {
      let isLoggedIn = checkifLoggedIn();
      if (isLoggedIn) {
        let user = getUserDetailsLocalStorage();
        if (
          ["account_manager", "system_admin"].indexOf(
            user.role
          ) > -1
        ) {
          if (this.$route.fullPath.indexOf("/admin") == -1) {
            this.$router.replace({ name: "admin" });
          }
        } else if (["consignee_user"].indexOf(user.role) > -1) {
          if (this.$route.fullPath.indexOf("/consignee") == -1) {
            this.$router.replace({ name: "consignee" });
          }
        }
        else if (["support_user"].indexOf(user.role) > -1) {
          if (this.$route.fullPath.indexOf("/support-user") == -1) {
            this.$router.replace({ name: "support_user" });
          }
        }
        else {
          if (this.$route.fullPath.indexOf("/client") == -1) {
            this.$router.replace({ name: "client" });
          }
        }
      } else {
        if (this.$route.fullPath.indexOf("/login") == -1) {
          this.$router.replace({ name: "login" });
        }
      }
    },
  },
  mounted() {
    if (this.$route.name != "error-page") {
      this.redirectIfLoggedIn();
    }
  },
};
</script>
